<template>
<div id="pdf">
    <v-layout wrap class="border-bottom-pdf font13-pdf">
        <v-flex xs3>
            <b>Tipo de Operación</b>
        </v-flex>
        <v-flex xs3>
            <b>Responsable</b>
        </v-flex>
        <v-flex xs3>
            <b>Nombre</b>
        </v-flex>
        <v-flex xs3>
            <b>No. Referencia</b>
        </v-flex>
    </v-layout>

    <v-layout wrap class="margin10top-pdf font11-pdf">
        <v-flex xs3>
            {{ modelPdf.tipo_operacion }}
        </v-flex>
        <v-flex xs3>
            {{ modelPdf.responsable_trafico }}
        </v-flex>
        <v-flex xs3>
            {{ modelPdf.nombre_trafico }}
        </v-flex>
        <v-flex xs3>
            {{ modelPdf.referencia }}
        </v-flex>
    </v-layout>
    <!------------------------------------------------------------------------->
    <v-layout wrap class="border-bottom-pdf margin10top-pdf font13-pdf">
        <v-flex xs4>
            <b>Fecha de Embarque</b>
        </v-flex>
        <v-flex xs4>
            <b>Fecha Estimada de Llegada</b>
        </v-flex>
        <v-flex xs4>
            <b>Agente Aduanal</b>
        </v-flex>
    </v-layout>

    <v-layout wrap class="margin10top-pdf font11-pdf">
        <v-flex xs4>
            {{ formatDate(modelPdf.fecha_embarque.substr(0, 10)) }}
        </v-flex>
        <v-flex xs4>
            {{ formatDate(modelPdf.fecha_llegada.substr(0, 10)) }}
        </v-flex>
        <v-flex xs4>
            {{ modelPdf.agente_aduanal.nombre }}
        </v-flex>
    </v-layout>
    <!------------------------------------------------------------------------->
    <v-flex xs12 style="margin-top: 40px;">
        <h5>
            DATOS GENERALES
        </h5>
    </v-flex>
    <v-layout wrap class="border-bottom-pdf margin10top-pdf font13-pdf">
        <v-flex xs4>
            <b>Aduana de Despacho</b>
        </v-flex>
        <v-flex xs4>
            <b>Agente de Carga o Reexpedidor</b>
        </v-flex>
        <v-flex xs4>
            <b>Referencia HBL</b>
        </v-flex>
    </v-layout>
    <v-layout wrap class="margin10top-pdf font11-pdf">
        <v-flex xs4>
            {{ modelPdf.aduana_despacho.nombre }}
        </v-flex>
        <v-flex xs4>            
            {{ modelPdf.agente_carga }}
        </v-flex>
        <v-flex xs4>
            {{ modelPdf.referencia_hbl }}            
        </v-flex>
    </v-layout>
    <!------------------------------------------------------------------------->
    <v-layout wrap class="border-bottom-pdf margin10top-pdf font13-pdf">
        <v-flex xs4>
            <b>BOOKING</b>
        </v-flex>
        <v-flex xs4>
            <b>Puerto de Embarque</b>
        </v-flex>
        <v-flex xs4>
            <b>Modalidad Transporte</b>
        </v-flex>
    </v-layout>
    <v-layout wrap class="margin10top-pdf font11-pdf">
        <v-flex xs4>
            {{ modelPdf.booking }}
        </v-flex>
        <v-flex xs4>
            {{ modelPdf.puerto_embarque }}
        </v-flex>
        <v-flex xs4>
            {{ modelPdf.modalidad_transporte }}
        </v-flex>
    </v-layout>
    <!------------------------------------------------------------------------->
    <v-layout wrap class="border-bottom-pdf margin10top-pdf font13-pdf">
        <v-flex xs3>
            <b>Tipo de Embarque</b>
        </v-flex>
        <v-flex xs3>
            <b>Transportista Intl Master</b>
        </v-flex>
        <v-flex xs3>
            <b>Referencia Master</b>
        </v-flex>
        <v-flex xs3>
            <b>Recinto Fiscal</b>
        </v-flex>
    </v-layout>
    <v-layout wrap class="margin10top-pdf font11-pdf">
        <v-flex xs3>
            {{ modelPdf.tipo_embarque }}
        </v-flex>
        <v-flex xs3>
            {{ modelPdf.transportista_master }}
        </v-flex>
        <v-flex xs3>
            {{ modelPdf.referencia_master }}
        </v-flex>
        <v-flex xs3>
            {{ modelPdf.recinto_fiscal }}
        </v-flex>
    </v-layout>
    <!------------------------------------------------------------------------->
    <v-flex xs12 style="margin-top: 40px;">
        <h5>
            DETALLE DE CARGA
        </h5>
    </v-flex>
    <v-layout wrap class="border-bottom-pdf margin10top-pdf font11-pdf">
        <v-flex xs1>
            <b>Num. Bultos</b>
        </v-flex>
        <v-flex xs1>
            <b>Tipo de Bultos</b>
        </v-flex>
        <v-flex xs1>
            <b>Peso Neto (Kgs)</b>
        </v-flex>
        <v-flex xs1>
            <b>Peso Bruto (Kgs)</b>
        </v-flex>
        <v-flex xs1>
            <b>Vol. (CBM)</b>
        </v-flex>
        <v-flex xs2>
            <b>Número de Contenedor</b>
        </v-flex>
        <v-flex xs5>
            <b>Tipo</b>
        </v-flex>
    </v-layout>
    <v-layout wrap class="margin10top-pdf font11-pdf" v-for="(item,index) in modelPdf.detalles_carga" :key="'detalles_carga'+index">
        <v-flex xs1 style="text-align: center;">
            {{ item.num_bultos }}
        </v-flex>
        <v-flex xs1 style="text-align: center;">
            {{ item.tipo_bultos }}
        </v-flex>
        <v-flex xs1 style="text-align: center;">
            {{ item.peso_neto }}
        </v-flex>
        <v-flex xs1 style="text-align: center;">
            {{ item.peso_bruto }}
        </v-flex>
        <v-flex xs1 style="text-align: center;">
            {{ item.vol_cbm }}
        </v-flex>
        <v-flex xs2 style="text-align: center;">
            {{ item.numero_contenedor }}
        </v-flex>
        <v-flex xs5>
            {{ item.tipo }}
        </v-flex>
    </v-layout>
    <!------------------------------------------------------------------------->
    <v-flex xs12 style="margin-top: 40px; page-break-inside:auto">
        <h5>
            Embarques
        </h5>

        <v-layout wrap class="border-bottom-pdf margin10top-pdf font11-pdf">
            <v-flex style="text-align: center;">
                <b>Descripción</b>
            </v-flex>
        </v-layout>
        <v-layout wrap class="margin10top-pdf font11-pdf" v-for="(item,index) in modelPdf.embarques" :key="'embarques'+index">
            <v-flex>
                <div style="text-align:center;"> {{ item.descripcion }} 
                </div> 
                <v-layout wrap class="border-bottom-pdf margin10top-pdf font11-pdf">
                    <v-flex xs2>
                        <b>Embarcador / Emisor</b>
                    </v-flex>
                    <v-flex xs2>
                        <b>RFC ò TAX ID</b>
                    </v-flex>
                    <v-flex xs1 style="text-align:center">
                        <b>País Procedencia / Destino</b>
                    </v-flex>
                    <v-flex xs2>
                        <b>Consignatario 1</b>
                    </v-flex>
                    <v-flex xs2>
                        <b>Consignatario 2</b>
                    </v-flex>
                    <v-flex xs2>
                        <b>Consignatario 3</b>
                    </v-flex>
                    <v-flex xs1>
                        <b>Otro</b>
                    </v-flex>
        </v-layout>
        <v-layout wrap class="margin10top-pdf font11-pdf" v-for="(itemDos,index) in item.especificaciones" :key="'especificaciones'+index">
            <v-flex xs2>
                {{ itemDos.embarcador!=""?itemDos.embarcador:itemDos.emisor }}
            </v-flex>
            <v-flex xs2>
                {{ itemDos.rfc_tax_id }}
            </v-flex>
            <v-flex xs1 style="text-align:center">
                {{ itemDos.pais_procedencia_destino }}
            </v-flex>
            <v-flex xs2>
                {{ itemDos.consignatario1 }}
            </v-flex>
            <v-flex xs2>
                {{ itemDos.consignatario2 }}
            </v-flex>
            <v-flex xs2>
                {{ itemDos.consignatario3 }}
            </v-flex>
            <v-flex xs1>
                {{ itemDos.otro }}
            </v-flex>
        </v-layout>
    </v-flex>
    </v-layout>
    </v-flex>
    <!------------------------------------------------------------------------->
    <v-flex xs12 style="margin-top: 40px; page-break-inside:auto">
        <h5>
            TRANSPORTE NACIONAL
        </h5>

        <v-layout wrap class="border-bottom-pdf margin10top-pdf font11-pdf">
            <v-flex xs4>
                <b>Transportista</b>
            </v-flex>
            <v-flex xs2>
                <b>RFC</b>
            </v-flex>
            <v-flex xs2>
                <b>Ruta Origen</b>
            </v-flex>
            <v-flex xs2>
                <b>Ruta Destino</b>
            </v-flex>
            <v-flex xs2>
                <b>Tarifa</b>
            </v-flex>
        </v-layout>
        <v-layout wrap class="margin10top-pdf font11-pdf" v-for="(item,index) in modelPdf.transportes" :key="'transportes'+index">
            <v-flex xs4>
                {{ item.transportista }}
            </v-flex>
            <v-flex xs2>
                {{ item.rfc }}
            </v-flex>
            <v-flex xs2>
                {{ item.ruta_origen }}
            </v-flex>
            <v-flex xs2>
                {{ item.ruta_destino }}
            </v-flex>
            <v-flex xs2>
                {{ item.tarifa }}
            </v-flex>
        </v-layout>
    </v-flex>
    <!------------------------------------------------------------------------->
    <v-flex xs12 style="margin-top: 40px; page-break-inside:auto">
        <h5>
            ALERTAS Y NOTIFICACIONES
        </h5>
        <v-layout wrap class="border-bottom-pdf margin10top-pdf font11-pdf">
            <v-flex xs4>
                <b>Usuario</b>
            </v-flex>
            <v-flex xs4>
                <b>Email</b>
            </v-flex>
            <v-flex xs4>
                <b>Nombre</b>
            </v-flex>
        </v-layout>
        <v-layout wrap class="margin10top-pdf font11-pdf" v-for="(item,index) in modelPdf.alertas" :key="'alertas'+index">
            <v-flex xs4>
                {{ item.tipo_usuario }}
            </v-flex>
            <v-flex xs4>
                {{ item.email }}
            </v-flex>
            <v-flex xs4>
                {{ item.nombre }}
            </v-flex>
        </v-layout>
    </v-flex>
    <!------------------------------------------------------------------------->
    <v-flex xs12 style="margin-top: 40px; page-break-inside:auto">
        <h5>
            FACTURAS
        </h5>

        <v-layout wrap class="border-bottom-pdf margin10top-pdf font11-pdf">
            <v-flex xs2>
                <b>Emisor/Destinatario</b>
            </v-flex>
            <v-flex xs2>
                <b>Tax Id</b>
            </v-flex>
            <v-flex xs1 style="text-align: center;">
                <b>Pais Vendedor</b>
            </v-flex>
            <v-flex xs1 style="text-align: center;">
                <b>Incoterm</b>
            </v-flex>
            <v-flex xs1 style="text-align: center;">
                <b>Número Factura</b>
            </v-flex>
            <v-flex xs1 style="text-align: center;">
                <b>Número Exportador</b>
            </v-flex>
            <v-flex xs1 style="text-align: center;">
                <b>Fecha Expedición</b>
            </v-flex>
            <v-flex xs1 style="text-align: center;">
                <b>Total USD</b>
            </v-flex>
            <v-flex xs1 style="text-align: center;">
                <b>Factura Proforma</b>
            </v-flex>
        </v-layout>
        <v-layout wrap class="margin10top-pdf font11-pdf" v-for="(item,index) in modelPdf.facturas" :key="'facturas'+index">
            <v-flex xs2>
                {{ item.emisor }}
            </v-flex>
            <v-flex xs2>
                {{ item.tax_id }}
            </v-flex>
            <v-flex xs1 style="text-align: center;">
                {{ item.pais_vendedor }}
            </v-flex>
            <v-flex xs1 style="text-align: center;">
                {{ item.incoterm }}
            </v-flex>
            <v-flex xs1 style="text-align: center;">
                {{ item.numero }}
            </v-flex>
            <v-flex xs1 style="text-align: center;">
                {{ item.numero_exportador }}
            </v-flex>
            <v-flex xs1 style="text-align: center;">
                {{ formatDate(item.fecha.substr(0, 10)) }}
            </v-flex>
            <v-flex xs1 style="text-align: right;">
                {{ item.importe }}
            </v-flex>
            <v-flex xs1 style="text-align: center;">
                <v-btn text small @click.native="verFacturaProforma(item.numero)" title="Ver Factura" v-tippy>
                    <v-icon>receipt</v-icon>
                </v-btn>
            </v-flex>
        </v-layout>
    </v-flex>
    <!------------------------------------------------------------------------->
    <v-flex xs12 style="margin-top: 40px; page-break-inside:auto">
        <h5>
            INCREMENTABLES
        </h5>

        <v-layout wrap class="border-bottom-pdf margin10top-pdf font11-pdf">
            <v-flex xs2>
                <b>Emisor/Destinatario</b>
            </v-flex>
            <v-flex xs2>
                <b>Tax Id</b>
            </v-flex>
            <v-flex xs2>
                <b>Número Factura</b>
            </v-flex>
            <v-flex xs2>
                <b>Secuencia Factura</b>
            </v-flex>
            <v-flex xs2>
                <b>Fecha Expedición</b>
            </v-flex>
            <v-flex xs2>
                <b>Total USD</b>
            </v-flex>
        </v-layout>
        <v-layout wrap class="margin10top-pdf font11-pdf" v-for="(item,index) in modelPdf.incrementables" :key="'incrementables'+index">
            <v-flex xs2>
                {{ item.emisor }}
            </v-flex>
            <v-flex xs2>
                {{ item.tax_id }}
            </v-flex>
            <v-flex xs2>
                {{ item.numero }}
            </v-flex>
            <v-flex xs2>
                {{ item.secuencia }}
            </v-flex>
            <v-flex xs2>
                {{ formatDate(item.fecha.substr(0, 10)) }}
            </v-flex>
            <v-flex xs2>
                {{ item.importe }}
            </v-flex>
        </v-layout>
    </v-flex>

    <!-- Modal Factura Proforma -->
    <v-dialog v-model="modalProforma" width="65%" max-width="100%">
        <v-card>
            <v-card-title>
                <v-spacer></v-spacer>
                <v-card class="primary white--text titulomodal">
                    <v-icon class="white--text">receipt</v-icon>&nbsp;Factura Proforma                    
                </v-card>                                
            </v-card-title>

            <v-divider></v-divider>
            <v-card-text>
                
                    <v-container grid-list-md >
                        <v-layout wrap>
                            <v-flex xs12>
                                <div id="facturaProforma">
                                    <div style="text-align:center;font-size:11px;font-weight:bold;line-height:11px!important;">
                                        <span>FACTURA PROFORMA</span>
                                    </div>
                                    <div style="font-size:7px;">
                                        <table id="tablaGenerales" border=0>
                                            <tr>
                                                <td colspan=6></td>
                                                <td width="7%"></td>
                                                <td width="18%" style="text-align:right;">Fecha: {{model_proforma.facturas.fecha}}</td>
                                            </tr>
                                            <tr>
                                                <td width="25%">IMPORTADOR</td>
                                                <td width="10%">FACTURA No.</td>
                                                <td width="10%">{{model_proforma.facturas.factura}}</td>
                                                <td width="10%"></td>
                                                <td width="10%"></td>
                                                <td width="10%">AGENTE DE CARGA</td>
                                                <td colspan=2>{{model_proforma.agente_carga}}</td>                                                
                                            </tr>
                                            <tr>
                                                <td>{{model_proforma.facturas.importador | uppercase}}</td>
                                                <td>FECHA</td>
                                                <td>{{model_proforma.facturas.fecha}}</td>
                                                <td></td>
                                                <td></td>
                                                <td>TRANSPORTISTA</td>
                                                <td colspan=2>{{model_proforma.transportista}}</td>                                                
                                            </tr>
                                            <tr>
                                                <td>
                                                    RFC: {{model_proforma.facturas.rfc_importador | uppercase}}                                                    
                                                </td>
                                                <td>INCOTERM</td>
                                                <td>{{model_proforma.facturas.incoterm}}</td>
                                                <td></td>
                                                <td></td>
                                                <td>HBL</td>
                                                <td colspan=2>{{model_proforma.hbl}}</td>
                                            </tr>
                                            <tr>
                                                <td>{{model_proforma.facturas.calle_importador | uppercase}}</td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td>BL O AWB</td>
                                                <td colspan=2>{{model_proforma.hbl}}</td>
                                            </tr>
                                            <tr>
                                                <td colspan=3>{{model_proforma.facturas.colonia_importador | uppercase}}</td>                                                
                                                <td></td>
                                                <td></td>
                                                <td>CONTENEDOR</td>
                                                <td colspan=2>{{model_proforma.contenedor}}</td>
                                            </tr>
                                            <tr>
                                                <td>                                                    
                                                    {{model_proforma.facturas.pais_importador | uppercase}}
                                                </td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td>                                                    
                                                    {{model_proforma.facturas.cp_importador | uppercase}}
                                                </td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td>SEGUROS</td>
                                                <td style="text-align:right;">{{model_proforma.facturas.seguros}}</td>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td>                                                    
                                                    &nbsp;
                                                </td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td>FLETES</td>
                                                <td style="text-align:right;">{{model_proforma.facturas.fletes}}</td>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td>PROVEEDOR</td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td>EMBALAJES</td>
                                                <td style="text-align:right;">{{model_proforma.facturas.embalajes}}</td>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td>{{model_proforma.facturas.proveedor | uppercase}}</td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td>OTROS INCREM</td>
                                                <td style="text-align:right;">{{model_proforma.facturas.otros}}</td>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td>RFC: {{model_proforma.facturas.rfc_proveedor | uppercase}}</td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td>{{model_proforma.facturas.calle_proveedor | uppercase}}</td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td colspan=3>{{model_proforma.facturas.colonia_proveedor | uppercase}}</td>                                                
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td>{{model_proforma.facturas.pais_proveedor | uppercase}}</td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td>{{model_proforma.facturas.cp_proveedor | uppercase}}</td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                        </table>
                                        <br/>
                                        <table id="tablaMercancias">
                                            <tr style="text-align:center;background-color:#DCDBDA;">
                                                <th width="8%">CANTIDAD DE EMPAQUES O BULTOS</th>
                                                <th width="7%">UNIDAD DE MEDIDA DE EMPAQUE</th>
                                                <th width="6%">NETO KGS</th>
                                                <th width="5%">BRUTO KGS</th>
                                                <th width="6%">CANTIDAD</th>
                                                <th width="3%">UM</th>
                                                <th width="17%">DESCRIPCIÓN DE LA MERCANCÍA</th>
                                                <th width="11%">MODELO</th>
                                                <th width="9%">SUB-MODELO</th>
                                                <th width="9%">FRACCIÓN ARANCELARIA</th> 
                                                <th width="7%">PRECIO UNITARIO</th>
                                                <th width="7%">VALOR COMERCIAL</th>
                                                <th width="5%">PAÍS ORIGEN</th>
                                            </tr>
                                            <tr v-for="(merca, index) in model_proforma.facturas.mercancias" v-bind:key="index"
                                                :class="index == (model_proforma.facturas.mercancias.length-1)?'sinBordes':'' "
                                            >                                                                                        
                                                <td style="text-align:center;">{{merca.numero_bultos}}</td>
                                                <td style="text-align:center;">{{merca.unidad_bultos | uppercase}}</td>
                                                <td style="text-align:right;">{{ formatNumber(merca.peso_neto,2) }}</td>
                                                <td style="text-align:right;">{{ formatNumber(merca.peso_bruto,2) }}</td>
                                                <td style="text-align:right;">{{ formatNumber(merca.cantidad,2) }}</td>
                                                <td style="text-align:center;">{{merca.clave_um}}</td>
                                                <td>{{merca.descripcion}}</td>
                                                <td style="text-align:center;">{{merca.modelo}}</td>
                                                <td style="text-align:center;">{{merca.submodelo}}</td>
                                                <td style="text-align:center;">{{merca.fraccion_arancelaria}}</td>
                                                <td style="text-align:right;">{{index == (model_proforma.facturas.mercancias.length-1)?'':'$ '}} {{ formatNumber(merca.valor_unitario,4) }}</td>
                                                <td style="text-align:right;">$ {{ formatNumber(merca.valor_dolares,2) }}</td>
                                                <td v-if="index == (model_proforma.facturas.mercancias.length-1)">USD</td>
                                                <td style="text-align:center;" v-else>{{model_proforma.facturas.pais_vendedor | uppercase}}</td>
                                            </tr>
                                            
                                        </table>
                                    </div>
                                </div>    
                            </v-flex>
                        </v-layout>
                    </v-container>
                
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click.native="modalProforma=false">
                    <v-icon>cancel</v-icon>&nbsp;Cerrar
                </v-btn>
                <v-btn :loading="loadingBtn" color="success" @click.native="descargarFacturaProforma()">
                    <v-icon>picture_as_pdf</v-icon>&nbsp;Descargar PDF
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</div>
</template>

<script>
import axios from "axios";
import html2pdf from "html2pdf.js";

export default {
    props: ['modelPdf'],
    data() {
        return {
            loadingBtn: false,
            modalProforma: false,
            model_proforma: {
                transportista:'',
                hbl:'',
                contenedor:'',
                facturas:'',
                agente_carga:'',                
            }
        }
    },    
    
    filters: {
        uppercase: function(value) {
            if (!value) return ''
            value = value.toString()
            return value.toUpperCase()
        },
    },

    methods: {
        
        formatDate(date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`;
        },
        formatNumber: function(numero, decimales){
            if (numero == undefined || numero == null || numero == "")
                return ""
            return (numero).toFixed(decimales).replace(/\d(?=(\d{3})+\.)/g, '$&,')
        },
        verFacturaProforma: function(numero_factura){
            this.$root.$dialogLoader.show('Espere un momento por favor..');
            var referencia = this.modelPdf.referencia;
            var rfc = this.$local_storage.get("rfc");
            axios.post(                
                this.$hostname + "catalogos/templates/datos_proforma/", {
                    factura: numero_factura,
                    referencia: referencia,
                    rfc: rfc
                }
            )
            .then(response => {
                this.model_proforma = response.data;
            })
            .catch(error => {
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al obtener los datos de la factura.",
                    footer: ""
                });
            }).then(() => {
                this.$root.$dialogLoader.hide();
                this.modalProforma = true;
            });
            
        },
        descargarFacturaProforma: function(){
            this.loadingBtn = true;
            var opt = {
                margin: [0.5, 0.1, 0.5, 0.1], //top, left, bottom, right
                filename: "Factura_Proforma_"+this.model_proforma.facturas.factura+".pdf",
                image: {
                    type: "jpeg",
                    quality: 1
                },
                html2canvas: {
                    scale: 2
                },
                pagebreak: {
                    mode: [ "css", "legacy"]
                },
                jsPDF: {
                    unit: "in",
                    format: "letter",
                    orientation: "portrait", //portrait, landscape     
                    compress: true,                                 
                }
            };

            var html = document.getElementById("facturaProforma");     
            var thisObj = this;             
            html2pdf()
                .set(opt)                    
                .from(html)                    
                .save()
                .then(function (pdf2) {
                                    thisObj.loadingBtn = false;
                                })                                     
        }
    }

}
</script>
<style scoped>
#pdf {
    margin-left: 20px;
    height: auto;
    width: auto;
    font-family: Arial, sans-serif;    
}
#facturaProforma {
    margin-left: 20px;
    height: auto;
    width: auto;
    font-family: Arial, sans-serif;    
    font-weight: bold;    
    line-height : 8px;
}
#tablaMercancias >>> td,th {
    border: 0.1mm solid black !important;
    padding-right:3px !important;
    padding-left:3px !important;
    padding-top:5px !important;
    padding-bottom:5px !important;    
}
.sinBordes > td {
    color:white!important;
    font-size:8px;
    background-color:black!important;
    height:40px!important;
    padding: 1px!important;
    border-top: 0px !important;
    border-right: 0px !important;
    border-bottom: 1px solid black !important;
    border-left: 0px !important;
}
</style>
